export default __webpack_public_path__ + "static/media/catalunya_light.0d6e3c12.png";